import { Helmet } from 'react-helmet'
import { Register } from '../../src/components'
import Footer from '../../src/components/Footer'
import Header from '../../src/components/Header'

export async function getServerSideProps(context) {
  const req = context.req;
  const host = req.headers.host;
  const fullUrl = `https://cure.com${req.url}`;

  if (host == 'mi.cure.com') {
    return {
      redirect: {
        destination: fullUrl,
        permanent: true,
      },
    };
  } else {
    return {
      props: { fullUrl }
    }
  }
}

export default function Index(props) {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.cure.com/my-account/register" />
      </Helmet>
      <Header />
      <div className="cure-inner-container">
        <Register />
      </div>
      <Footer />
    </>
  )
}
